interface ServiceWithPrice {
  title: string;
  price: string;
  quantity?: number;
}

interface PriceRange {
  min: number;
  max: number;
  hasRange: boolean;
}

export const PriceCalculator = {
  // Calculate total with range support
  calculateTotalRange: (services: Set<ServiceWithPrice>): PriceRange => {
    let minTotal = 0;
    let maxTotal = 0;
    let hasRange = false;

    Array.from(services).forEach((service) => {
      const quantity = service.quantity ?? 1;

      // Check for range price first (e.g., "RM15~30")
      const rangeMatch = service.price.match(/RM([\d.]+)~([\d.]+)/i);
      if (rangeMatch) {
        const minPrice = parseFloat(rangeMatch[1]);
        const maxPrice = parseFloat(rangeMatch[2]);
        minTotal += minPrice * quantity;
        maxTotal += maxPrice * quantity;
        hasRange = true;
        return;
      }

      // Extract single price (e.g., "RM30")
      const match = service.price.match(/RM([\d.]+)/i);
      if (match) {
        const price = parseFloat(match[1]);
        minTotal += price * quantity;
        maxTotal += price * quantity;
      }
    });

    return { min: minTotal, max: maxTotal, hasRange };
  },

  // Legacy function for backward compatibility (returns min price)
  calculateTotal: (services: Set<ServiceWithPrice>): number => {
    return PriceCalculator.calculateTotalRange(services).min;
  },

  formatPrice: (price: number): string => {
    return `RM${price.toFixed(2)}`;
  },

  // Format price range (shows range if min != max)
  formatPriceRange: (range: PriceRange): string => {
    if (range.hasRange && range.min !== range.max) {
      return `RM${range.min.toFixed(2)}~${range.max.toFixed(2)}`;
    }
    return `RM${range.min.toFixed(2)}`;
  }
};

export type { ServiceWithPrice }; 